export default __webpack_public_path__ + "static/media/semcasting-amobee-logo.e194d5f8.svg";